export const API = 'https://api.edamam.com/api/recipes/v2?'

export const app_id = '85c3f716'

export const app_key = 'c5ecc5dd8e499f08c9c6634a69f1838c'